import apiClient from "../apiClient";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const SubcategoriesUpdate = () => {
    const [categories, setCategories] = useState([]);
    const [values, setSubcategory] = useState({
        CategoryId: "",
        Description: "",
    });

    const [error, setError] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const subcategoryId = location.pathname.split("/")[2];

    const sortedCategories = useMemo(
        () => [...categories].sort((a, b) => (a.Description || "").localeCompare(b.Description || "")),
        [categories]
    );

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesRes, subcategoriesRes] = await Promise.all([
                    apiClient.get("/categories"),
                    apiClient.get("/subcategories"),
                ]);

                const categoryRows = Array.isArray(categoriesRes.data) ? categoriesRes.data : [];
                const subcategoryRows = Array.isArray(subcategoriesRes.data) ? subcategoriesRes.data : [];
                const selectedSubcategory = subcategoryRows.find((item) => String(item.SubcategoryId) === String(subcategoryId));

                setCategories(categoryRows);

                if (selectedSubcategory) {
                    setSubcategory({
                        CategoryId: selectedSubcategory.CategoryId || categoryRows[0]?.CategoryId || "",
                        Description: selectedSubcategory.SubcategoryDescription || "",
                    });
                } else if (categoryRows.length > 0) {
                    setSubcategory((prev) => ({ ...prev, CategoryId: categoryRows[0].CategoryId }));
                }
            } catch (err) {
                setError(true);
            }
        };
        fetchData();
    }, [subcategoryId]);

    const handleChange = (e) => {
        setSubcategory((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        if (!values.CategoryId || !values.Description?.trim()) return setError(true);
        try {
            await apiClient.put(`/subcategories/${subcategoryId}`, values);
            navigate("/Subcategories");
        } catch (err) {
            setError(true);
        }
    };

    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Update Subcategory</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Subcategories">Subcategories</Link> / Update</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="subcategory-category">Category</label>
                    <select id="subcategory-category" name="CategoryId" value={values.CategoryId} onChange={handleChange}>
                        {sortedCategories.map((category) => (
                            <option key={category.CategoryId} value={category.CategoryId}>
                                {category.Description}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="subcategory-description">Subcategory Description</label>
                    <input
                        id="subcategory-description"
                        type="text"
                        placeholder="Subcategory Description"
                        name="Description"
                        value={values.Description}
                        onChange={handleChange}
                    />
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Update Subcategory</button>
                        <Link className="btn-link" to="/Subcategories">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not update subcategory. Check input and try again.</p>}
                </div>
            </section>
        </div>

    );
};

export default SubcategoriesUpdate;
